<template>
  <div class="card mt-4">
    <div class="card-header pb-0 p-3">
      <div class="row">
        <div class="col-6 d-flex align-items-center">
          <h6 class="mb-0">审批管理</h6>
        </div>
        <div class="col-6 text-end">
          <soft-button color="dark" variant="gradient" @click="loadTable">
            <i :class="showTable? 'fas fa-coffee me-2':'fas fa-pen me-2'"></i>
            {{ showTable? '休息一下' :'处理进件申请' }}
          </soft-button>
        </div>
      </div>
    </div>
    <div class="card-body p-3">
      <div class="row">
        <div class="col-md-6 mb-md-0 mb-4">
          <div
            class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row"
          >
            <img
              class="w-10 me-3 mb-0"
              src="@/assets/img/small-logos/logo-spotify.svg"
              alt="logo"
            />
            <h6 class="mb-0">
              已配置有效通道数:{{ approved }}
            </h6>
          </div>
        </div>
        <div class="col-md-6">
          <div
            class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row"
          >
            <img
              class="w-10 me-3 mb-0"
              src="@/assets/img/small-logos/logo-slack.svg"
              alt="logo"
            />
            <h6 class="mb-0">
              等待处理新进件:{{ newItems }}
            </h6>
          </div>
        </div>
      </div>

      <div v-if="showTable">
        <submission-tables/>
      </div>

    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import SubmissionTables from "../submission/SubmissionTables.vue";
import img1 from "@/assets/img/logos/mastercard.png";
import img2 from "@/assets/img/logos/visa.png";
import { getmerchpayinfos } from "@/api/merch.js"

export default {
  name: "ApproveSubmission",
  components: {
    SoftButton,
    SubmissionTables,
  },
  data() {
    return {
      img1,
      img2,
      showTable: true,
      approved: 0,
      newItems: 0,
    };
  },
  methods: {
    loadTable() {
      this.showTable = !this.showTable;
    },
    // 获取进件数据
    fetchSubmissions() {
      getmerchpayinfos().then(response => {
        if (response.code === 0) {
          console.log("submissions:", response.desc.length)
          for (var i = 0; i < response.desc.length; i++) {
            if (response.desc[i].status === "approved") {
              this.approved++
            }else if (response.desc[i].status === "new"){
              this.newItems++
            }
          }
        } else {
          alert("获取进件资料失败：" + response.desc);
        }
      }).catch(error => {
        console.error("获取进件数据时出错：", error);
        alert("获取进件资料失败，请稍后再试。");
      });
    },
  },
  mounted() {
    this.fetchSubmissions()
  }
};
</script>
